import { render, staticRenderFns } from "./systemDoorItem2.vue?vue&type=template&id=61130f3c&"
import script from "./systemDoorItem2.vue?vue&type=script&lang=ts&"
export * from "./systemDoorItem2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports